export default __webpack_public_path__ + "static/media/049-robot.269ef749.svg";